import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  inputStatus: {
    fontSize: 12,
    fontWeight: 'bold',
    // marginInlineEnd: theme.spacing(1.5),
    color: ({ infoType }) => {
      switch (infoType) {
        case 'success':
          return 'green';
        case 'warning':
          return 'orange';
        case 'error':
          return 'red';
        default:
          return 'gray';
      }
    },
  },
  infoText:{
    position: 'relative',
    left: '10px',
  },
  inputStatusSuccess: {
    color: 'green',
  },
  inputStatusWarning: {
    color: 'orange',
  },
  inputStatusIcon: {
    fontSize: 14,
    marginInlineEnd: theme.spacing(0.5),
  },
  asterisk: {
    color: '#ef5350',
    display: 'inline-block',
  },
}));